function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 16 3.21875 L 15.125 4.71875 L 3.125 25.5 L 2.28125 27 L 4 27 L 28 27 L 29.71875 27 L 28.875 25.5 L 16.875 4.71875 L 16 3.21875 z M 16 7.21875 L 26.25 25 L 5.75 25 L 16 7.21875 z M 15 14 L 15 20 L 17 20 L 17 14 L 15 14 z M 15 21 L 15 23 L 17 23 L 17 21 L 15 21 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Bitstream Vera Sans"
  }));
};

export default __webpack_public_path__ + "static/media/error.a0c07733.svg";
export { SvgComponent as ReactComponent };